<div class="table table-responsive">
        <table class="table">
        <thead>
            <tr class="custom-table-head">
                <th>
                    <a style="cursor: pointer" (click)="currentPage = 0; getItems()" title="Actualiser">
                        <i class="fa fa-redo-alt"></i></a>&nbsp;&nbsp; #
                </th>
                <th>Matricule</th>
                <th>Nom Prenom</th>
                <th>Consultation</th>
                <th>Pharmacie</th>
                <th>Biologie</th>
                <th>Radio</th>
                <th>Hospi</th>
                <!-- <th>Kiné</th> -->
                <th>Optique</th>
                <th>Dentisterie</th>
                <th>Transport Médicalisé</th>
                <th>Bilan santé</th>
                <th>Procréa</th>
                <th>Autre exa</th>
                <th>Total indiv</th>
                <th class="txt-align-center">Photo</th>
            </tr>
        </thead>

        <tbody>
            <tr [class.isAssure]="item?.statut_codification =='A'" [class.isSupplementaire]="item?.is_supplementaire" 
                *ngFor="let item of items; let indice = index">
                <td class="txt-align-center">{{ currentPage>1?(((currentPage - 1) * this.itemsPerPage) + (indice+1)):indice+1 }}</td>
                <td>{{ item?.matricule }}</td>
                <td>{{ item?.nom }} {{ item?.prenom }}</td>
                <td>{{ item?.cons | integerFormat }}</td>
                <td>{{ item?.pharma | integerFormat }}</td>
                <td>{{ item.bio | integerFormat }}</td>
                <td>{{ item?.ima | integerFormat }}</td>
                <td>{{ item?.hos | integerFormat }}</td>
                <!-- <td>{{ item?.kine | integerFormat }}</td> -->
                <td>{{ item?.opt | integerFormat }}</td>
                <td>{{ item?.den | integerFormat }}</td>
                <td>{{ item?.tra | integerFormat }}</td>
                <td>{{ item?.biln | integerFormat }}</td>
                <td>{{ item?.amp | integerFormat }}</td>
                <td>{{ item?.exa | integerFormat }}</td>
                <td>{{ item?.total_depense | integerFormat }}</td>
                <td>
                    <img [src]="item.beneficiaire_image_url | safe" (error)="handleImageError(item)" 
                         style="width: 30px; height: 30px; display: block; border-radius: 50px;" />
                </td>
            </tr>
            <tr *ngIf="items && items.length > 0">
                <td colspan="3" style="text-align: center;">Total</td>
                <td >{{get_total_value('cons_total') | integerFormat}}</td>
                <td >{{get_total_value('pharma_total') | integerFormat}}</td>
                <td >{{get_total_value('bio_total') | integerFormat}}</td>
                <td >{{get_total_value('ima_total') | integerFormat}}</td>
                <td >{{get_total_value('hos_total') | integerFormat}}</td>
                <td >{{get_total_value('opt_total') | integerFormat}}</td>
                <td >{{get_total_value('den_total') | integerFormat}}</td>
                <td >{{get_total_value('tra_total') | integerFormat}}</td>
                <td >{{get_total_value('biln_total') | integerFormat}}</td>
                <td >{{get_total_value('amp_total') | integerFormat}}</td>
                <td >{{get_total_value('exa_total') | integerFormat}}</td>
                <td >{{get_total_value('total_depense_total') | integerFormat}}</td>
            </tr>
        </tbody>

        <tfoot>
            <tr *ngIf="items && items.length > 0">
                <td colspan="19"> <!-- Updated colspan to match total columns -->
                    <div class="row pagination-part">
                        <div class="col-md-9" style="text-align: center">
                            <pagination [maxSize]="5" [boundaryLinks]="true" [itemsPerPage]="itemsPerPage"
                                [totalItems]="totalItems" [(ngModel)]="currentPage" class="pagination-sm"
                                previousText="&lsaquo;" nextText="&rsaquo;" firstText="&laquo;" lastText="&raquo;"
                                (pageChanged)="pageChanged($event)">
                            </pagination>
                        </div>

                        <div class="col-md-3">
                            <div class="paginator-per-page">
                                <app-element-by-page-paginator (paginationChange)="changePaginationSize($event)"
                                    [defaultItemPerPage]="itemsPerPage">
                                </app-element-by-page-paginator>

                                <span class="span_total_entree pull-right">Total : {{ totalItems }}</span>
                            </div>
                        </div>
                    </div>
                </td>
            </tr>

            <tr *ngIf="!items || items.length == 0">
                <td colspan="19"> <!-- Updated colspan to match total columns -->
                    <div class="col-md-12 txt-align-center">
                        Aucune donnée disponible
                    </div>
                </td>
            </tr>
        </tfoot>
    </table>
</div>